const MAX_GENERATOR_SEED = 0x7fffffff;
const SEED_STEP = 7919;
const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

function normalizeNumericSeed(seed: number): number {
  if (!Number.isFinite(seed)) return 1;

  const normalized = Math.abs(Math.trunc(seed)) % MAX_GENERATOR_SEED;
  return normalized === 0 ? 1 : normalized;
}

function hashStringSeed(seed: string): number {
  let hash = FNV_OFFSET_BASIS;

  for (let index = 0; index < seed.length; index++) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, FNV_PRIME);
  }

  return normalizeNumericSeed(hash >>> 0);
}

export function normalizeSeed(seed: number | string): number {
  if (typeof seed === 'number') {
    return normalizeNumericSeed(seed);
  }

  const trimmed = seed.trim();
  if (/^\d+$/.test(trimmed)) {
    return normalizeNumericSeed(Number(trimmed));
  }

  return hashStringSeed(trimmed);
}

export function resolveSeed(seed?: number | string): number {
  if (seed === undefined) {
    return normalizeNumericSeed(Math.floor(Math.random() * MAX_GENERATOR_SEED));
  }

  return normalizeSeed(seed);
}

export function advanceSeed(seed: number | string, steps = 1): number {
  const normalized = normalizeSeed(seed);
  const distance =
    ((Math.trunc(steps) % MAX_GENERATOR_SEED) + MAX_GENERATOR_SEED) %
    MAX_GENERATOR_SEED;

  return ((normalized - 1 + distance * SEED_STEP) % MAX_GENERATOR_SEED) + 1;
}
